import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { useQuery, useQueryClient } from '@tanstack/react-query';

// constants
import RocketSuccessModal from '../../../components/modals/RocketSuccessModal';

// constants
import routes from '../../../constants/routes';

import formulaKeys from '../../../hooks/formulas/_queryKeys';

// models
import { FormulaDetailModel } from '../../../models/formula.model';

import API from '../../../services/api';

const ApprovedSuccessModal: FC<
    React.PropsWithChildren<{
        text?: string;
        message?: string;
        destination?: string | undefined;
        handleClose: (value: boolean) => void;
    }>
> = ({
    text,
    message = 'is live and will start sending to your customers shortly!',
    destination,
    handleClose,
}) => {
    const history = useHistory();
    const queryClient = useQueryClient();

    const { formulaId } = useParams<{ formulaId: string }>();
    const formulaIdNum = parseInt(formulaId);

    // Use cached formula data if available; fetch from API as a fallback so
    // the success modal always shows the correct name and type.
    const { data: formula } = useQuery<FormulaDetailModel>({
        queryKey: formulaKeys.formulaById(formulaIdNum),
        queryFn: async () => {
            const { data } = await API.fetchFormula(formulaIdNum);
            return data;
        },
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });

    const destinationRoute = destination || routes.formulaLive(formulaId);

    const handleClick = () => {
        queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        history.replace(destinationRoute, history.location.state);
        handleClose(false);
    };

    return (
        <RocketSuccessModal
            text={
                text ??
                [formula?.name, formula?.message_type?.toUpperCase()]
                    .filter(Boolean)
                    .join(' - ')
            }
            handleClick={handleClick}
            message={message}
        />
    );
};

export default ApprovedSuccessModal;
